module.exports = __webpack_public_path__ + "img/house-chimney.c39a0461.svg";